<template>
  <b-col md="3" id="filter" class="align-self-start p-3">
    <div v-if="availableCategories && availableCategories.length > 0">
      <label class="title">Categories</label>
      <div class="category--slider">
        <div class="mb-0" v-for="(category, i) in availableCategories" v-bind:key="i">
          <a
            class="ml-2 filterText"
            href="#"
            v-on:click="changeCategory(category.Category_id)"
            :class="{ active: selectedCat === category.Category_id }"
            v-if="category.products_num > 0"
          >
            <font-awesome-icon
              :icon="((selectedCat === category.Category_id && categoryToggled == 1) || (selectedCatParent != null && selectedCatParent === category.Category_id && categoryToggled == 1)) ? 'minus' : 'plus'"
              class="mr-2"
              size="xs"
              :class="{'hidden': category.sub_categories.length == 0}"
            ></font-awesome-icon>
            {{ category.Desc }} ({{ category.products_num }})
          </a>

          <div v-for="(sub_category, j) in category.sub_categories" :key="j">
            <a
              href="#"
              v-if="sub_category.products_num > 0 && ((selectedCat === category.Category_id && categoryToggled == 1) || (selectedCatParent != null && selectedCatParent === sub_category.Parent_category_id && categoryToggled == 1))"
              class="mb-0 ml-5 d-block filterText"
              v-on:click="changeCategory(sub_category.Category_id,sub_category.Parent_category_id)"
              :class="{ active: selectedCat === sub_category.Category_id }"
            >
              {{ sub_category.Desc }} ({{
              sub_category.products_num
              }})
            </a>
          </div>
        </div>
      </div>
    </div>
    <label class="title">Filter by colour:</label>

    <b-form-checkbox
      v-for="(color, i) in Array.from(availableColors).sort()"
      v-bind:key="i"
      v-model="chosenColors"
      v-bind:value="color"
      v-if="getProductsCount(color) > 0"
    >
      <span
        class="ml-2 filterText"
        v-bind:class="chosenColors.includes(color) ? 'selected' : ''"
      >{{ color }} ({{getProductsCount(color)}})</span>
    </b-form-checkbox>
  </b-col>
</template>

<script>
export default {
  name: "MainFilterPanel",
  data() {
    return {
      selectedCat: null,
      selectedCatParent: null,
      categoryToggled: 1,
      chosenColors: [],
    };
  },
  props: [
    "availableColors",
    "availableCategories",
    "availableProducts",
    "initialAvailableProducts",
  ],
  watch: {
    chosenColors: function () {
      this.applyFilters();
    },
  },
  methods: {
    getProductsCount(color) {
      return this.initialAvailableProducts.filter((product) => {
        const thisProductColor = product.Colour.split("/");
        for (const j of thisProductColor) {
          if (j != "" && color == j) {
            return true;
          }
        }
        if (product.colors) {
          for (const productColor of product.colors) {
            const productColor2 = productColor.Colour.split("/");
            for (const j of productColor2) {
              if (j != "" && color == j) {
                return true;
              }
            }
          }
        }

        return false;
      }).length;
    },

    changeCategory(category, parent_category = null) {
      if (this.selectedCat != category) {
        this.selectedCat = category;
        this.selectedCatParent = parent_category;
        this.$emit("change-category", category);
        this.categoryToggled = 1;
      } else {
        this.categoryToggled = this.categoryToggled == 1 ? 0 : 1;
      }
    },
    applyFilters() {
      this.$emit("update-filters", this.chosenColors);
    },
  },
  mounted() {
    if (this.availableCategories.length > 0) {
      this.selectedCat = this.availableCategories[0].Category_id;
    }
  },
};
</script>

<style scope>
.hidden {
  opacity: 0;
}
#filter .title {
  text-transform: uppercase;
  margin-bottom: 10px;
  font-size: 15px;
}
#filter .filterText {
  color: black;
}
#filter .filterText.active {
  font-weight: bold;
}
#filter .category--slider {
  margin-bottom: 20px;
}
.selected {
  font-weight: 600;
}

#applyBtn {
  border-radius: 15px;
}
</style>
